import React from 'react';
import { RosterSparkline } from './RosterSparkline';
import { rosterNumber } from './rosterCopy';

export const RosterMetric = ({ id, label, metric, unit, deltaUnit, subtitle, comparison, language, copy }) => {
  const value = metric?.value, delta = metric?.delta;
  const direction = delta == null ? '' : delta > 0 ? '↑' : delta < 0 ? '↓' : '→';
  return <div className="roster-metric" data-testid={`${id}-metric`}>
    <div className="roster-metric-label" data-testid={`${id}-label`}>{label}</div>
    <div className="roster-metric-value" data-testid={`${id}-value`}>
      {rosterNumber(value, language)}{value != null && unit && <span>{unit}</span>}
    </div>
    <div className="roster-metric-caption" data-testid={`${id}-caption`}>
      {value == null ? copy.missing : subtitle || '\u00a0'}
    </div>
    <div className="roster-metric-bottom">
      <span className="roster-trend" title={comparison} aria-label={`${copy.comparison}: ${delta == null ? copy.missing : `${delta} ${deltaUnit || ''}`}. ${comparison}`} data-testid={`${id}-trend`}>
        {delta == null ? '—' : `${direction} ${delta > 0 ? '+' : ''}${rosterNumber(delta, language)}${deltaUnit ? ` ${deltaUnit}` : ''}`}
      </span>
      <RosterSparkline series={metric?.series} testId={`${id}-sparkline`} label={label} />
    </div>
  </div>;
};